import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <Typography variant="h2">Co chcesz zrobić?</Typography>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Link to="/strefa" style={{ width: "100%", textDecoration: "none" }}>
            <Box
              sx={{
                color: "white",
                backgroundColor: "#86a315",
                borderRadius: 2,
                p: 4,
                height: "100%",
                width: "100%",
                minHeight: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition:
                  "background-color 0.3s, transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "#5d2f88",
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 900 }}>
                Chcę skonsultować się w trudnej sprawie
              </Typography>
              <Typography variant="body1" color="white">
                Na przykład samookaleczanie, trudności wychowawcze, sytuacje w
                których nie wiem co zrobić.
              </Typography>
            </Box>
          </Link>
        </Grid>

        {/* Kafelek 2 */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Link
            to="/formularze"
            style={{ width: "100%", textDecoration: "none" }}
          >
            <Box
              sx={{
                color: "white",
                backgroundColor: "#86a315",
                borderRadius: 2,
                p: 4,
                height: "100%",
                width: "100%",
                minHeight: 180,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                transition:
                  "background-color 0.3s, transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  backgroundColor: "#5d2f88",
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 900 }}>
                Chcę zgłosić przekroczenie granic lub przemoc
              </Typography>
              <Typography variant="body1" color="white">
                Na przykład podejrzenie przemocy domowej, przemoc w grupie
                równieśniczej, podejrzewanie wykorzystania seksualnego.
              </Typography>
            </Box>
          </Link>
        </Grid>
      </Grid>
    </>
  );
}
